(function () {
  'use strict';

  var BAND_COLORS = {
    'black':        '#202020',
    'navy':         '#1e3868',
    'hunter':       '#375955',
    'hunter green': '#375955',
    'olive':        '#454411',
    'olive green':  '#454411',
    'fog':          '#C0C5D1',
    'fog grey':     '#C0C5D1',
    'white':        '#f5f3f0',
    'ice':          '#BEF1FA',
    'ice blue':     '#BEF1FA',
    'blush':        '#c9a09a',
    'rose':         '#D95C8C',
    'vibrant pink': '#e0207a',
    'coral':        '#e86070',
    'lavender':     '#9e86c0',
    'rust':         '#c04818',
    'poppy':        '#cc1e1e',
    'crimson':      '#8b1820',
    'mint':         '#5ab870'
  };

  var LIGHT_BAND_COLORS = ['white', 'ice', 'ice blue', 'blush', 'fog', 'fog grey'];

  var state = {
    month:         null,
    monthLabel:    '',
    nameEnabled:   false,
    name:          '',
    nameFont:      'BandFontCollege',
    nameFontLabel: 'College',
    isLight:       false
  };

  var root, bandShort,
      nameDisplay, namePlaceholder,
      monthValueInput, nameValueInput, nameFontValueInput;

  function el(id) { return document.getElementById(id); }

  function init() {
    root = document.querySelector('[data-bfb-root]');
    if (!root) return;

    bandShort          = el('bfb-preview-band-short');
    nameDisplay        = el('bfb-name-display');
    namePlaceholder    = el('bfb-name-placeholder');
    monthValueInput    = el('bfb-month-value');
    nameValueInput     = el('bfb-name-value');
    nameFontValueInput = el('bfb-name-font-value');

    bindMonthOptions();
    bindNameToggle();
    bindNameInput();
    bindFontButtons();
    bindColorSync();
    bindZoomHints();

    var initialColor = detectCurrentColor();
    if (initialColor) applyBandColor(initialColor);

    renderName();
  }

  // --- Month selection ---
  function bindMonthOptions() {
    var options = root.querySelectorAll('.bfb-month-option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');

        var month = opt.dataset.month;
        var label = opt.querySelector('.bfb-month-name');
        var flower = opt.querySelector('.bfb-flower-name');
        state.month      = month;
        state.monthLabel = (label ? label.textContent.trim() : month)
                         + (flower ? ' — ' + flower.textContent.trim() : '');
        monthValueInput.value = state.monthLabel;
      });
    });
  }

  // --- Zoom hint / lightbox ---
  var lightboxOverlay, lightboxImg, lightboxLabel;

  function buildLightbox() {
    if (lightboxOverlay) return;

    lightboxOverlay = document.createElement('div');
    lightboxOverlay.className = 'bfb-lightbox-overlay';

    var box = document.createElement('div');
    box.className = 'bfb-lightbox-box';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'bfb-lightbox-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', closeLightbox);

    lightboxImg = document.createElement('img');
    lightboxLabel = document.createElement('p');
    lightboxLabel.className = 'bfb-lightbox-label';

    box.appendChild(closeBtn);
    box.appendChild(lightboxImg);
    box.appendChild(lightboxLabel);
    lightboxOverlay.appendChild(box);
    document.body.appendChild(lightboxOverlay);

    lightboxOverlay.addEventListener('click', function (e) {
      if (e.target === lightboxOverlay) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  function openLightbox(src, label) {
    buildLightbox();
    lightboxImg.src = src;
    lightboxImg.alt = label || '';
    lightboxLabel.textContent = label || '';
    lightboxOverlay.classList.add('is-open');
  }

  function closeLightbox() {
    if (lightboxOverlay) lightboxOverlay.classList.remove('is-open');
  }

  function bindZoomHints() {
    var hints = root.querySelectorAll('.bfb-zoom-hint');
    hints.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(btn.dataset.zoomSrc, btn.dataset.zoomLabel);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          openLightbox(btn.dataset.zoomSrc, btn.dataset.zoomLabel);
        }
      });
    });
  }

  // --- Name toggle ---
  function bindNameToggle() {
    var toggle = el('bfb-name-toggle');
    var fields = el('bfb-name-fields');
    if (!toggle || !fields) return;
    toggle.addEventListener('change', function () {
      state.nameEnabled = this.checked;
      if (this.checked) {
        fields.removeAttribute('hidden');
      } else {
        fields.setAttribute('hidden', '');
        state.name = '';
        nameValueInput.value = '';
        nameFontValueInput.value = '';
      }
      renderName();
    });
  }

  // --- Name input ---
  function bindNameInput() {
    var input   = el('bfb-name-text');
    var counter = el('bfb-name-char-count');
    if (!input) return;
    input.addEventListener('input', function () {
      state.name = this.value;
      nameValueInput.value = this.value;
      if (counter) counter.textContent = this.value.length;
      renderName();
    });
  }

  // --- Font buttons ---
  function bindFontButtons() {
    var btns = root.querySelectorAll('.bfb-font-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.nameFont      = btn.dataset.fontFamily;
        state.nameFontLabel = btn.dataset.fontLabel;
        nameFontValueInput.value = state.nameFontLabel;
        renderName();
      });
    });
  }

  // --- Color sync ---
  function detectCurrentColor() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var v = radios[i].value.toLowerCase();
      if (BAND_COLORS[v]) return v;
    }
    var selects = document.querySelectorAll('variant-selects select, .product-form select');
    for (var j = 0; j < selects.length; j++) {
      var v2 = selects[j].value.toLowerCase();
      if (BAND_COLORS[v2]) return v2;
    }
    return null;
  }

  function applyBandColor(colorName) {
    var hex = BAND_COLORS[colorName];
    if (!hex) return;
    if (bandShort) bandShort.style.backgroundColor = hex;

    state.isLight = LIGHT_BAND_COLORS.indexOf(colorName) !== -1;
    var textColor = state.isLight ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.8)';
    if (nameDisplay) nameDisplay.style.color = textColor;
  }

  function bindColorSync() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'radio' || t.tagName === 'SELECT') {
        var v = t.value.toLowerCase();
        if (BAND_COLORS[v]) {
          applyBandColor(v);
        } else {
          var found = detectCurrentColor();
          if (found) applyBandColor(found);
        }
      }
    });
  }

  // --- Render ---
  function renderName() {
    if (!nameDisplay || !namePlaceholder) return;
    if (state.nameEnabled && state.name.length > 0) {
      nameDisplay.textContent = state.name;
      nameDisplay.style.fontFamily = "'" + state.nameFont + "', cursive";
      nameDisplay.style.display = 'inline';
      namePlaceholder.style.display = 'none';
    } else {
      nameDisplay.style.display = 'none';
      namePlaceholder.style.display = 'inline';
    }
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
